import React from "react";
import "./Loader.css";
import loaderIcon from "../../assets/images/loader.png";

const Loader = () => {
  return (
    <div className="backdrop">
        <div className="loader">
            <img src={loaderIcon} alt="Logo" className="logo"/>
        </div>
    </div>
  );
};

export default Loader;
